import { Component, OnInit, OnDestroy } from '@angular/core';
import { OidcService, AuthService } from './core';
import { TranslateService } from '@ngx-translate/core';
import { CommonRouteService } from './core/services/common-route.service';
import { ErrorNotificationService } from './core/services/error-notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  acknowledgementData: any = null;
  isAcknowledgementOpen = false;
  errorMessage: string | null = null;
  private ackSubscription: Subscription = new Subscription();
  private errorSubscription: Subscription = new Subscription();
  private ackQueue: any[] = [];
  private errorTimer: any = null;

  constructor(
    public translate: TranslateService,
    public authService: AuthService,
    readonly oidcService: OidcService,
    private commonRouteService: CommonRouteService,
    private errorNotificationService: ErrorNotificationService) {
    translate.setDefaultLang('English');
  }


  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);

    if (params.has('logout')) {
      return;
    }

    this.oidcService.autoLogin();

    this.ackSubscription = this.commonRouteService.acknowledgement$.subscribe(items => {
      this.ackQueue = [...items];
      this.showNextAcknowledgement();
    });

    this.errorSubscription = this.errorNotificationService.error$.subscribe(msg => {
      this.errorMessage = msg;
      if (this.errorTimer) { clearTimeout(this.errorTimer); }
      if (msg) {
        this.errorTimer = setTimeout(() => { this.onErrorDismissed(); }, 5000);
      }
    });
  }

  onErrorDismissed(): void {
    this.errorNotificationService.clear();
  }

  private showNextAcknowledgement(): void {
    if (this.ackQueue.length > 0) {
      this.acknowledgementData = this.ackQueue.shift();
      this.isAcknowledgementOpen = true;
    }
  }

  onAcknowledgementClosed(): void {
    this.isAcknowledgementOpen = false;
    this.acknowledgementData = null;
    setTimeout(() => this.showNextAcknowledgement(), 0);
  }

  ngOnDestroy(): void {
    this.ackSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }
}
